interface ValidationMessageProps {
  show: boolean
  message: string
}

export default function ValidationMessage({ show, message }: ValidationMessageProps) {
  if (!show) return null
  return (
    <div className="mt-4 rounded-xl border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-300">
      {message}
    </div>
  )
}
